import { ActionTypes } from "./actions";
import logic from "src/utils/genLogic";

const apiNamespace = "page";

export default [];
